<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">Detalles</div>
  </div>
  <div class="card-content" [formGroup]="prestacionesForm" #localFormRef="ngForm">
    <div class="card-body">
      <div [formGroup]="buscadorServicioForm" class="mb-4">
        <div class="d-flex justify-content-between container__detalle">
          <!-- ng-select + lupa -->
          <div class="d-flex justify-content-between">
            <ng-select
              class="content__select"
              style="width: 30rem;"
              formControlName="servicio"
              [items]="serviceSearchCatalog"
              [selectOnTab]="true"
              [loading]="serviceSearchLoading"
              bindLabel="nombre"
              placeholder="Ingrese nombre de servicio"
              (change)="onServiceSelectedFromSearch($event)"
              (clear)="clearServiceSearch()"
              (search)="searchService($event, 'nombre')"
              notFoundText="Sin resultado">
            </ng-select>

            <button
              type="button"
              class="btn btn-default ml-2 btn__search"
              (click)="openServiceListModal(listaBuscaServicio)">
              <i class="flaticon-search"></i>
            </button>
          </div>

          <!-- Botón Agregar -->
          <div class="d-flex align-items-center">
            <button
              type="button"
              class="btn btn-success ml-2"
              (click)="agregarServicioSeleccionado()">
              Agregar
              <i class="flaticon-add"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- FIN BUSCADOR -->

      <div class="row">
        <table class="table" formArrayName="prestaciones">
          <thead>
            <tr>
              <th>N°</th>
						<th WIDTH="65%">Prestación</th>
              <th>Valor</th>
              <th></th>
            </tr>
          </thead>
          <tbody *ngFor="let prestacion of prestacionesForm.get('prestaciones')['controls']; let i = index">
            <tr [formGroupName]="i">
              <td>{{ i + 1 }}</td>
              <td>
                <input
                  type="text"
                  class="form-control"
                  formControlName="descripcion"
                  (blur)="onSubmit()" />
                <div
                  *ngIf="(localFormRef.touched || localFormRef.dirty) && prestacionesForm.get('prestaciones')['controls'][i].invalid"
                  class="text-danger">
                </div>
              </td>
              <td>
                <input
                  type="text"
                  class="form-control"
                  formControlName="valor"
                  (blur)="onSubmit()" />
              </td>
              <td>
                <button class="btn btn-danger" (click)="removePrestacion(i)">
                  <i class="flaticon-delete text-white"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mb-5">
        <div class="d-flex justify-content-center">
          <button class="btn btn-success" (click)="addPrestacionForm()">
            <i class="flaticon-add-circular-button"></i>Agregar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row mt-5">
	<div class="offset-md-7 offset-lg-7 col-md-5 col-lg-5">
		<div class="card">
			<div class="card-body">
				<div class="form-group row mx-auto">
					<div class="col-6 label-control">Líquido a pagar</div>
					<div class="col-6 text-right">
						{{ liquido | currency : "$ " : "symbol" : "1.0-0" : "es" }}
					</div>
				</div>
				<!-- <div class="form-group row mx-auto">
					<div class="col-8 label-control">Porcentaje de Retención</div>
					<div class="col-4 text-right input-group">
						<input type="number" style="text-align: right" [disabled="true"] [(ngModel)]="porcentajeRetencion" class="form-control" (change)="cambiarRetencion()" />
						<div class="input-group-append">
							<span class="input-group-text">%</span>
						</div>
					</div>
				</div> -->
				<div class="form-group row mx-auto">
					<div class="col-6 label-control">Retención ({{ porcentajeRetencion * 100 | number : "1.2-2" }})%</div>
					<div class="col-6 text-right">
						{{ montoRetencion | currency : "$ " : "symbol" : "1.0-0" : "es" }}
					</div>
				</div>
				<div class="form-group row mx-auto">
					<div class="col-6 label-control">Total</div>
					<div class="col-6 text-right">
						{{ totalBruto | currency : "$ " : "symbol" : "1.0-0" : "es" }}
					</div>
				</div>
			</div>
		</div>
</div>
<!-- MODAL LISTA DE SERVICIOS -->
<ng-template #listaBuscaServicio let-d="dismiss">
  <div class="modal-xl">
    <div class="modal-header">
      <div class="modal-wizard-label">
        <div class="modal-wizard-title">Lista de servicios disponibles</div>
        <div class="modal-wizard-desc">Seleccione un servicio para agregarlo a los detalles</div>
      </div>
    </div>
    <div class="modal-body">
      <ngx-datatable
        *ngIf="serviceRows.length > 0"
        #servicesTable
        [rows]="serviceRows"
        class="material"
        [columnMode]="'flex'"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="70"
        [externalPaging]="true"
        [count]="pageServices.totalElements"
        [offset]="pageServices.pageNumber"
        [limit]="pageServices.pageSize"
        (page)="setPageServices($event)"
        [selectionType]="SelectionType.single"
        (activate)="onActivateService($event)"
        [messages]="{
          emptyMessage: 'Sin datos para mostrar',
          totalMessage: 'Elementos totales',
          selectedMessage: false
        }">

        <ngx-datatable-column name="nombre" [flexGrow]="3" [sortable]="false" [resizeable]="false">
          <ng-template ngx-datatable-header-template>
            <span class="text-table-alignment">Nombre</span>
          </ng-template>
          <ng-template ngx-datatable-cell-template let-row="row">
            <span class="text-table-alignment nombre-modal">{{ row.nombre }}</span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="precio" [flexGrow]="2" [sortable]="false" [resizeable]="false">
          <ng-template ngx-datatable-header-template>
            <span class="number-table-alignment">Precio</span>
          </ng-template>
          <ng-template ngx-datatable-cell-template let-row="row">
            <span class="number-table-alignment precio-modal">
              {{ row.precio | currency : '$ ' : 'symbol' : '1.0-0' : 'es' }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="exento" [flexGrow]="1.5" [sortable]="false" [resizeable]="false">
          <ng-template ngx-datatable-header-template>
            <span class="text-table-alignment">Exento</span>
          </ng-template>
          <ng-template ngx-datatable-cell-template let-row="row">
            <span class="text-table-alignment exento-modal">
              {{ row.exento ? 'Exento' : 'Afecto' }}
            </span>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>

      <div *ngIf="serviceRows.length == 0">
        <span>No hay servicios en la lista</span>
      </div>
    </div>
    <div class="modal-footer"></div>
  </div>
</ng-template>
<!-- FIN MODAL LISTA DE SERVICIOS -->
